module.exports = __webpack_public_path__ + "433ba646e50cdfa823e8caf7e2adabc9.png";